import '../../style/index.less';
import './index.less';



// WEBPACK FOOTER //
// ./components/skeleton/style/index.tsx